import { Doughnut, Line } from "react-chartjs-2";

import InfoLink from "@/containers/InfoLink";

import { BaseWidget } from "./BaseWidget";
import {
  eventPropsForPie,
  eventPropsForTimeline,
  lineOptions,
  pieOptions,
} from "./chart_options";
import { CountText } from "./CountText";
import {
  getLabelsAndDatasetsForDoughnutChart,
  getLabelsAndDatasetsForLineChart,
} from "./helpers";

// ------------------------------------------------------------------------------------

const EngagementInfoLink = () => (
  <InfoLink
    href={L.HELP_ARTICLE_ENGAGEMENT}
    content={L.MENTIONS_ENGAGEMENT_SCORE_EXPLANATION}
  />
);

// ------------------------------------------------------------------------------------

const hasData = (data, chartType) => {
  const dataField =
    chartType === "line" ? "numEngagementsPerWeek" : "numEngagementsPerSource";

  if (!data) return false;

  for (const d of data) {
    // check if some of the keys we care about exist first
    if (!d.numEngagementsPerWeek && !d.numEngagementsPerSource) {
      return false;
    }

    for (const val of d[dataField]) {
      if (parseInt(val[1]) > 0) return true;
    }
  }

  return false;
};

const sumEngagement = (data, field) => {
  let sum = 0;

  for (const d of data) {
    for (const f of d[field]) {
      sum += f[1];
    }
  }
  return sum;
};

export const EngagementWidget = (props) => {
  const adjustedData = JSON.parse(JSON.stringify(props.data));

  if (adjustedData?.length) {
    for (const data of adjustedData) {
      if (data?.numEngagementsPerSource)
        data.numEngagementsPerSource = data.numEngagementsPerSource.filter(
          (d) => d[1] >= 0
        );

      if (data?.numEngagementsPerWeek)
        data.numEngagementsPerWeek = data.numEngagementsPerWeek.filter(
          (d) => d[1] >= 0
        );
    }
  }

  const isStacked = true;
  const doughnutChartData = getLabelsAndDatasetsForDoughnutChart(
    "numEngagementsPerSource",
    hasData(adjustedData) ? adjustedData : null,
    isStacked
  );

  const lineChartData = getLabelsAndDatasetsForLineChart(
    "numEngagementsPerWeek",
    hasData(adjustedData) ? adjustedData : null,
    isStacked
  );

  const pieChartOptions = pieOptions(isStacked, props.size);
  const lineChartOptions = lineOptions(isStacked, props.size);

  const totalEngagement = hasData(adjustedData)
    ? sumEngagement(adjustedData, "numEngagementsPerSource")
    : 0;

  return (
    <BaseWidget
      {...props}
      hasData={hasData(adjustedData, props.chartType)}
      extraHeader={<EngagementInfoLink />}
    >
      {props.chartType === "pie" ? (
        <Doughnut
          data={doughnutChartData}
          options={{
            ...pieChartOptions,
            ...eventPropsForPie(doughnutChartData, props, "engagement"),
          }}
        />
      ) : props.chartType === "sum" ? (
        <>
          <CountText count={totalEngagement} {...props} />
        </>
      ) : (
        <Line
          data={lineChartData}
          options={{
            ...lineChartOptions,
            ...eventPropsForTimeline(lineChartData, props),
          }}
        />
      )}
    </BaseWidget>
  );
};
